(() => {
  if (typeof window === 'undefined' || !window.customElements || customElements.get('z-stacked-gallery')) return;

  class ZStackedGallery extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      const { signal } = this.abortController;
      this.slides = Array.from(this.querySelectorAll('.z-gallery__slide[data-z-gallery-open]'));
      this.dialog = this.querySelector('[data-z-gallery-dialog]');
      this.lightboxImage = this.querySelector('[data-z-gallery-lightbox-image]');
      this.counter = this.querySelector('[data-z-gallery-counter]');
      this.previousButton = this.querySelector('[data-z-gallery-previous]');
      this.nextButton = this.querySelector('[data-z-gallery-next]');
      this.closeButton = this.querySelector('[data-z-gallery-close]');
      this.index = this.boundIndex(this.index || 0);

      if (!this.slides.length || !this.dialog || !this.lightboxImage) return;

      this.addEventListener(
        'click',
        (event) => {
          const target = event.target instanceof Element ? event.target : null;
          if (!target) return;

          const opener = target.closest('[data-z-gallery-open]');
          if (opener && this.contains(opener)) {
            event.preventDefault();
            this.openAt(Number(opener.dataset.zGalleryOpen), opener);
            return;
          }

          if (target.closest('[data-z-gallery-close]')) {
            event.preventDefault();
            this.dialog.close();
            return;
          }

          if (target.closest('[data-z-gallery-previous]')) {
            event.preventDefault();
            this.go(-1);
            return;
          }

          if (target.closest('[data-z-gallery-next]')) {
            event.preventDefault();
            this.go(1);
          }
        },
        { signal }
      );

      this.dialog.addEventListener(
        'click',
        (event) => {
          if (event.target === this.dialog) this.dialog.close();
        },
        { signal }
      );

      this.dialog.addEventListener(
        'close',
        () => {
          const opener = this.opener;
          this.opener = null;
          opener?.focus({ preventScroll: true });
        },
        { signal }
      );

      this.updateLightbox();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = undefined;
      this.opener = null;
    }

    boundIndex(index) {
      const numericIndex = Number(index);
      const requestedIndex = Number.isInteger(numericIndex) ? numericIndex : 0;
      return Math.max(0, Math.min(this.slides.length - 1, requestedIndex));
    }

    openAt(index, opener) {
      this.index = this.boundIndex(index);
      this.opener = opener || this.slides[this.index];
      this.updateLightbox();

      if (!this.dialog.open) this.dialog.showModal();
      this.closeButton?.focus({ preventScroll: true });
    }

    go(step) {
      const nextIndex = this.boundIndex(this.index + step);
      if (nextIndex === this.index) return;
      this.index = nextIndex;
      this.updateLightbox();
    }

    updateLightbox() {
      const slide = this.slides[this.index];
      const sourceImage = slide?.querySelector('img');
      if (!sourceImage) return;

      const originalSource = sourceImage.getAttribute('src');
      if (originalSource) this.lightboxImage.setAttribute('src', originalSource);
      this.lightboxImage.alt = sourceImage.alt;

      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (this.previousButton) this.previousButton.disabled = this.index === 0;
      if (this.nextButton) this.nextButton.disabled = this.index === this.slides.length - 1;
    }
  }

  customElements.define('z-stacked-gallery', ZStackedGallery);
})();
